import React, {useState, useEffect} from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '../../context/hooks/useAxiosPrivate';
import { Spinner, Modal, Button, Row, Form, Toast } from 'react-bootstrap';
import '../../appstyles/ClientsCSS/ClientsDetails.css'
import '../../appstyles/QuotesCSS/OrderDetails.css'
import ClientPDF from './ClientPDF';
//import SupplierPDF from '../Tracking/SupplierPDF';
//import PermissionWrapper from '../../context/PermissionWrapper';

const unitNames = {
    KG: 'Kilogramos',
    G: 'Gramos',
    TON: 'Tonelada',
    TON_S: 'Tonelada corta',
    TON_L: 'Tonelada larga',
    LB: 'Libra',
    OZ: 'Onzas',
    L: 'Litro',
    ML: 'Mililitro',
    GAL_UK: 'Galón UK',
    GAL_US: 'Galón US',
    FCL: 'FCL',
  };

function OrderDetails() {
  const axiosInstance = useAxiosPrivate();
  const { quoteId } = useParams();
  const [quote, setQuote] = useState(null);
  const navigate = useNavigate();
  const [feedback, setFeedback] = useState('');
  const [client_consecutive, setClientConsecutive] = useState('');
  const [loading, setLoading] = useState(false);
  //Nombre cliente y proveedor
  const NCM_STRINGS = [
    "Nutrition and Chemical Market S.A.S.",
    "NUTRITION AND CHEMICAL MARKET SAS",
    "NUTRITION AND CHEMICAL MARKET S.A.S."
  ];
  //Toast
  const [showApprove, setShowApprove] = useState(false);
  const [showDecline, setShowDecline] = useState(false);
  const [showToast, setShowToast] = useState(false);

  const handleCloseApprove = () => setShowApprove(false);
  //const handleShowApprove = () => setShowApprove(true);

  const handleShowApprove = async () => {
  try {
    if (
      quote.incoterm === 'Local' &&
      !NCM_STRINGS.includes(quote.client_name) &&
      NCM_STRINGS.includes(quote.supplier_name)
    ) {
      const inventoryResponse = await axiosInstance.get(
        `/api/logistics-inventory/?page=1&size=30&assigned_quote_id=${quoteId}`
      );

      const inventoryData = inventoryResponse.data?.data || [];

      if (inventoryData.length === 0) {
        const productParams = quote.products.map((product) => ({
          product_id: product.product_id,
          product_name: product.product_name,
          quantity: parseInt(product.quantity),
        }));

        navigate(`/assigninventory/${quoteId}`, { state: { productParams } });
        return;
      }
    }

    setShowApprove(true);
  } catch (error) {
    console.error('Error fetching quote or inventory data:', error);
  }
};


  const handleCloseDecline = () => setShowDecline(false);
  const handleShowDecline = () => setShowDecline(true);

  useEffect(() => {
    axiosInstance.get(`api/quote/${quoteId}/`)
      .then(response => {
        setQuote(response.data);
      })
      .catch(error => {
        console.error('Failed to fetch quote details', error);
      });
  }, [quoteId, axiosInstance]);

  const declineQuote = () => {
    axiosInstance.post(`api/quote/approval/`, 
      {
        status: 'Rechazado',
        quote_id: +quoteId,
        feedback: feedback,
      }
    )
      .then(() => {
        window.location.reload();
      })
      .catch(error => {
        console.error('Failed to decline quote', error);
      });
  };

  const approveQuote = () => {
    axiosInstance.post(`api/quote/approval/`,
      {
        status: 'Aprobado',
        quote_id: +quoteId,
        feedback: feedback,
        client_consecutive: client_consecutive,
      }
    )
      .then(() => {
        window.location.reload();
      })
      .catch(error => {
        console.error('Failed to approve quote', error);
      });
  };

  const backToRequests = () => {
    setLoading(true);
    axiosInstance.post(`api/quote/back-requested/?quote_id=${quoteId}`)
      .then(() => {
        navigate(`/requestlist`);
      })
      .catch(error => {
        if (error.response && error.response.status === 400 && error.response.data.error === 'Tracking status is not PENDING, cannot be reversed') {
          setShowToast(true);
          setLoading(false);
        } else {
          console.error('Failed to submit request:', error);
        }
      });
  };

  if (!quote) {
    return(
    <div className='loading-container'>
      <p style={{fontFamily: 'Roboto, sans-serif'}}>Cargando...</p>
      <Spinner animation="border" variant="info" style={{width: '4.5rem', height: '4.5rem'}} />
    </div>
    );
  }

  return (
    <div className='maestros-details'>
      <h2>Detalles de Cotización</h2>
      <hr />
      <div className='orders-details-actions'>
      <h4>Cotización No. {quote.quote_id}</h4>

      <div className='orders-actions'>
      <ClientPDF/>
      </div>
      
      </div>

      <h4 style={{fontWeight: '700', color: '#07514F'}}>{quote.products.length > 1 ? 'Productos' : 'Producto'}</h4>
      {quote.products.map(product => (
      <Row key={product.id}>
      <div className='first-col'>
          <p><strong>Id del producto:</strong> {product.product_id}</p>
          <p><strong>Nombre del producto:</strong> {product.product_name} </p>
          <p><strong>Fabricante:</strong> {product.product_manufacturer}</p>
          <p>
            <strong>Empaque:</strong>
            {product.product_detail 
            ? `${product.product_detail.packaging_size} ${unitNames[product.product_detail.unity]} en ${product.product_detail.packaging_type}` 
            :'N/A'
            }   
          </p>
      </div>

      <div className='second-col'>
          <p><strong>Cantidad:</strong> {product.quantity}</p>
          <p><strong>Unidad:</strong> {unitNames[product.quantity_unit]}</p>
          <p><strong>Precio Unitario:</strong> {product.unit_price}</p>
          <p><strong>Moneda:</strong> {quote.currency}</p>
      </div>
      <hr />
      </Row>
      ))}

      <h4 style={{fontWeight: '700', color: '#07514F'}}>Cotización</h4>
      <div style={{display: 'flex', flexDirection: 'row'}}>
      <div className='first-col'>
          <p><strong>ID del Cliente:</strong> {quote.client_id} </p>
          <p><strong>Nombre del Cliente:</strong> {quote.client_name} </p>
          <p><strong>ID del Proveedor:</strong> {quote.supplier_id} </p>
          <p><strong>Nombre del Proveedor:</strong> {quote.supplier_name} </p>
          <p><strong>Incoterm:</strong> {quote.incoterm} </p>
          <p><strong>Terminos de pago (días):</strong> {quote.payment_terms} </p>
          <p><strong>Tipo de compra:</strong> {quote.buy_type} </p>
          <p><strong>Estado: </strong> 
          <span style={{ color: quote.status === 'Aprobado' ? 'green' : quote.status === 'Rechazado' ? 'red' : 'black' }}>
            {quote.status}
          </span>
          </p>
      </div>  

      <div className='second-col'>
          <p><strong>Consecutivo:</strong> {quote.consecutive} </p>
          <p><strong>Creación de cotización:</strong> {quote.order_date} </p>
          <p><strong>Fecha estimada de despacho:</strong> {quote.requested_delivery_date} </p>
          <p><strong>Fecha solicitada:</strong> {quote.requested_date} </p>
          <p><strong>Ciudad de llegada:</strong> {quote.arrival_city} </p>
          <p><strong>Detalles de entrega:</strong> {quote.delivery_details ? quote.delivery_details : 'N/A'} </p>
          <p><strong>Feedback:</strong> {quote.feedback} </p>
      </div>
      </div>

      <Modal show={showApprove} onHide={handleCloseApprove}>
      <Modal.Header closeButton>
        <Modal.Title>
          Aprobar Cotización
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Escribe una observación y el consecutivo del cliente para ésta cotización que será <strong>aprobada</strong></p>

        <Form.Group controlId="feedback">
        <Form.Label>Feedback</Form.Label>
        <Form.Control 
          type="textarea" 
          value={feedback} 
          onChange={(e) => setFeedback(e.target.value)} 
        />
        </Form.Group>

        <Form.Group controlId="client_consecutive">
        <Form.Label>Consecutivo del Cliente</Form.Label>
        <Form.Control 
          type="textarea" 
          value={client_consecutive} 
          onChange={(e) => setClientConsecutive(e.target.value)} 
        />
        </Form.Group>

      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseApprove}>
          Cerrar
        </Button>
        <Button variant="success" onClick={approveQuote}>
          Aprobar
        </Button>
      </Modal.Footer>
      </Modal>

      <Modal show={showDecline} onHide={handleCloseDecline}>
      <Modal.Header closeButton>
        <Modal.Title>
          Rechazar Cotización
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <p>Escribe una observación para ésta cotización que será <strong>rechazada</strong></p>

      <Form.Group controlId="feedback">
      <Form.Label>Feedback</Form.Label>
      <Form.Control 
        type="textarea" 
        value={feedback} 
        onChange={(e) => setFeedback(e.target.value)} 
      />
      </Form.Group>

      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseDecline}>
          Cerrar
        </Button>
        <Button variant="danger" onClick={declineQuote}>
          Rechazar
        </Button>
      </Modal.Footer>
      </Modal>

      {/*Botones*/}
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '5px',
        }}
      >
      {quote.status !== 'Aprobado' && quote.status !== 'Rechazado' && (
      <>
      <Button 
        variant="success" 
        style={{marginTop: '20px', width: '15%'}}
        onClick={handleShowApprove}
        >
          Aprobar
      </Button>
      
      <Button 
          variant='danger'
          style={{marginTop: '20px', width: '15%'}}
          onClick={handleShowDecline}
      >
        Rechazar
      </Button>
      </>
      )}
      {quote.status !== 'Rechazado' && (
      <Button 
        variant="secondary" 
        style={{marginTop: '20px', width: '20%'}}
        onClick={backToRequests}
        >
          {loading ? 'Cargando...' : 'Devolver cotización'}
      </Button>
      )}
      </div>

      <Button 
        variant="secondary" 
        style={{marginTop: '20px', width: '20%'}}
        onClick={() => navigate(`/quoteslist`)}
        >
          Volver
      </Button>

      <Toast
        onClose={() => setShowToast(false)} 
        show={showToast}
        delay={10000}
        autohide 
        bg='warning'
        style={{ position: 'fixed', top: 100, right: 20, zIndex: 1 }}  // Estilo para fijarlo en la esquina superior derecha
      >
      <Toast.Header>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-lg" viewBox="0 0 16 16">
          <path d="M7.005 3.1a1 1 0 1 1 1.99 0l-.388 6.35a.61.61 0 0 1-1.214 0zM7 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0"/>
        </svg>
        <strong className="me-auto">Error</strong> 
        <small>Ahora</small>
      </Toast.Header>
      <Toast.Body>
        <strong>La cotización no puede ser devuelta</strong> porque su trazabilidad ya ha comenzado.
      </Toast.Body>
      </Toast>
        
    </div>
  )
}

export default OrderDetails